// src/utils/crypto.ts

const secretKey = process.env.REACT_APP_CIPHER_SECRET_KEY // Secret Key

const cipherSaltEncrypt = (salt: any) => {
    const textToChars = (text: string = "") =>
      text.split("").map((c: string) => c.charCodeAt(0));
    const byteHex = (n: any) => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code: any) =>
      textToChars(salt).reduce((a: number, b: number) => a ^ b, code);
    return (text: string ="") =>
      text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
  };

export const cipher = cipherSaltEncrypt(secretKey);

const decipherSaltdecrypt = (salt: string) => {
        const textToChars = (text: string="") => text.split('').map((c: string) => c.charCodeAt(0));
        const applySaltToChar = (code: any) => textToChars(salt).reduce((a: number, b: number) => a ^ b, code);
        return (encoded: string) => {
          // Add null/undefined check to prevent the error
          if (!encoded || typeof encoded !== 'string') {
            return '';
          }
          return encoded?.match(/.{1,2}/g)
            ?.map((hex: string) => parseInt(hex, 16))
            .map(applySaltToChar)
            .map((charCode: number) => String.fromCharCode(charCode))
            .join('') || '';
        }
      }

export const decipher = decipherSaltdecrypt(secretKey)

  